import { AccountManager } from "@yardzen/api-dtos";
import { AxiosResponse } from "axios";
import { apiClient } from "../base-client";

const baseUrl = "build-projects";

export async function getOrAssignAccountManager(
  buildProjectId: string,
  userId: string,
): Promise<AxiosResponse<AccountManager>> {
  return apiClient.post(
    `${baseUrl}/${buildProjectId}/account-manager/get-or-assign`,
    { userId },
  );
}
